module.exports = __webpack_public_path__ + "img/left_bump.bacf6857.jpg";